import React from 'react';
import { Text } from '../../../../../components/Typography';
import styles from './ConversationTags.module.scss';

interface ConversationTagsProps {
  tickers: string[];
}

const ConversationTags: React.FC<ConversationTagsProps> = ({ tickers }) => {
  if (!tickers || tickers.length === 0) {
    return null;
  }

  return (
    <div className={styles.tagsContainer}>
      {tickers.map((ticker) => (
        <div key={ticker} className={styles.tag}>
          <Text size="small" weight="medium">
            {ticker}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default ConversationTags;
